// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3SnSO","noInteraction":"EventWrapper_noInteraction__2-cEE","pointerPassthrough":"EventWrapper_pointerPassthrough__258iI"};